module.exports = __webpack_public_path__ + "static/media/dollar.15e727d4.svg";